import { render, staticRenderFns } from "./navbar-y.vue?vue&type=template&id=7a5fd52b&scoped=true"
import script from "./navbar-y.vue?vue&type=script&lang=js"
export * from "./navbar-y.vue?vue&type=script&lang=js"
import style0 from "./navbar-y.vue?vue&type=style&index=0&id=7a5fd52b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5fd52b",
  null
  
)

export default component.exports